import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAffiliateShowSubaffiliateResponse } from '../types';
import { AFFILIATE_SHOW_SUBAFFILIATE_CONDITION_API_URL, AFFILIATE_SHOW_SUBAFFILIATE_CONDITION_QUERY } from '../constants';

export default function useAffiliateShowSubaffiliateConditionQuery(id: Ref<number>): IContextQueryResult<
  IAffiliateShowSubaffiliateResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateShowSubaffiliateResponse>({
    queryKey: [AFFILIATE_SHOW_SUBAFFILIATE_CONDITION_QUERY, id],
    queryFn: ({ signal }) => fetchGet<IAffiliateShowSubaffiliateResponse>(
      AFFILIATE_SHOW_SUBAFFILIATE_CONDITION_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
